import React, { useState, useEffect, useContext } from 'react'
import axios from 'axios'

import { UserContext } from '../../UserContext'

// This is the integration with Mosaic

import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Button from '@material-ui/core/Button';
import CheckBoxOutlinedIcon from '@material-ui/icons/CheckBoxOutlined';
import CheckBoxOutlineBlankOutlinedIcon from '@material-ui/icons/CheckBoxOutlineBlankOutlined';
import CircularProgress from '@material-ui/core/CircularProgress';
import moment from 'moment'
import Alert from 'react-s-alert'

// require('dotenv').config()

const MosaicCredit = ({ view, agree, setAgree, disclosures, agreed, repEmail, setAgreed, bundleId, name, projectID, email, phone, street, city, state, zip }) => {

  const { activeUser, setActiveUser } = useContext(UserContext);

  // console.log(activeUser.username)

  let names = name.split(' ')

  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [middleName, setMiddleName] = useState('string')
  const [emailA, setEmailA] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [streetA, setStreetA] = useState('')
  const [cityA, setCityA] = useState('')
  const [stateA, setStateA] = useState('')
  const [zipA, setZipA] = useState('')
  const [annualIncome, setAnnualIncome] = useState('')
  const [secondaryIncome, setSecondaryIncome] = useState(0)
  const [social, setSocial] = useState('')
  const [birthMonth, setBirthMonth] = useState('')
  const [birthDay, setBirthDay] = useState('')
  const [birthYear, setBirthYear] = useState('')
  const [bunId, setBunId] = useState('')
  const [confirmedApp, setConfirmedApp] = useState(false)
  const [ownHome, setOwnHome] = useState(false)
  const [applicationId, setApplicationId] = useState('')
  const [creditResult, setCreditResult] = useState('Pending')
  const [creditMessage, setCreditMessage] = useState({})
  const [ecoa, setEcoa] = useState('')
  const [cpa2, setCpa2] = useState('')
  const [viewCpa2, setViewCpa2] = useState(false)
  const [ehl, setEhl] = useState('')
  const [arb, setArb] = useState('')
  const [viewArb, setViewArb] = useState(false)
  const [esign, setEsign] = useState('')
  const [viewEsign, setViewEsign] = useState(false)
  const [income, setIncome] = useState('')
  const [viewIncome, setViewIncome] = useState(false)
  const [otherInc, setOtherInc] = useState('')
  const [own, setOwn] = useState('')
  const [pad, setPad] = useState('')
  const [stateDisc, setStateDisc] = useState('')
  const [viewStateDisc, setViewStateDisc] = useState(false)
  const [gd, setGd] = useState('')
  const [viewGd, setViewGd] = useState(false)
  const [tcpa, setTcpa] = useState('')
  const [viewTcpa, setViewTcpa] = useState(false)
  const [mpp, setMpp] = useState('')
  const [trueLender, setTrueLender] = useState('')
  const [loading, setLoading] = useState(false)

  const listOfStates = require('us-state-converter')

  const creditLoad = () => {
    setTimeout(function () {
      setLoading(false)
      // mosaicApiGetApp('getApp', applicationId)
    }, 7000)
  }

  useEffect(() => {
    setFirstName(names[0])
    setLastName(names[1])
    setEmailA(email)
    setPhoneNumber(phone)
    setStreetA(street)
    setCityA(city)
    setStateA(state)
    setZipA(zip)
  },[name, email, phone, street, city, state, zip])

  useEffect(() => {
    setBunId(bundleId)
  }, [bundleId])

  let abbrState = listOfStates.abbr(stateA)

  // let disclosures = [
  //   {
  //     "assetCode": "CPA_2",
  //     "version": "08172021_CPA_2_MOSC",
  //     "assetType": "form",
  //     "title": "",
  //     "contents": [
  //       {
  //         "contentType": "text",
  //         "title": "",
  //         "data": "AUTHORIZATION TO OBTAIN CONSUMER REPORTS & TO SHARE INFORMATION\nAuthorization And Consent To Pull Credit Pre-Qualification Check — Eligibility Inquiry\n\nYou understand that by checking the box and clicking the button, Mosaic Platform Lender (together with its successors, assigns, vendors, representatives, loan servicer providers and each of the foregoing’s respective service providers will perform a review of your pre-qualification to determine if you are potentially eligible for credit. This pre-qualification check will result in a soft credit pull. This pre-qualification inquiry does not affect your credit score and is only visible to you on your credit report. During the pre-qualification check, you authorize the review of consumerto verify the information in your pre-qualification check, which may include contacting third parties.\n\nApplication Submission — Credit Inquiry\n\nIf the pre-qualification review shows that you are eligible for a loan and you decide to move forward with obtaining a loan, you will click a button indicating your intent to submit a loan application. The submission of a loan application and the execution of a loan agreement and promissory note will result in a hard credit pull when loan funds are disbursed. This subsequent hard credit pull will be reflected on your credit report as an inquiry, may be viewed by other creditors, and may impact your FICO Score.\n\nAuthorization To Obtain Consumer Reports (Eligibility/Credit Inquiry)\n\nYou authorize us to obtain consumer reports and information about you from one or more consumer reporting agencies (i.e. Experian, Equifax, TransUnion) or other third parties, including when you submit a pre-qualification check, submit a subsequent loan application, and periodically throughout the term of any loan.\n\nThis authorization includes your agreement that Mosaic Platform Lender and its service providers may use the information obtained from such reports or third parties, among other things: (a) in relation to your pre-qualification for potential credit; (b) in relation to your eligibility for credit in connection with a loan application; (c) in order to verify and authenticate your identity; (d) for internal modeling and analysis; and (e) to administer the presale or sale of a loan.\nIt also includes your agreement that we may use the information obtained from such reports or third parties, among other things; (a) in relation to the servicing, monitoring, collection or enforcement of any loan originated; (b) to determine at any time your continued eligibility for credit; (c) for internal modeling and analysis; and (d) to administer the presale or sale of a loan.\nAuthorization to Share Information\nYou authorize us to share any information obtained in your pre-qualification check, loan application, credit report, or from any third parties to effectuate the underlying credit transaction. You understand and authorize us to share the information obtained and collected during servicing, collection and enforcement of any loan. You also authorize us to share any information obtained (inclusive of your credit report) with potential investors or purchasers of any loan product you obtain."
  //       }
  //     ]
  //   },
  //   {
  //     "assetCode": "EHL",
  //     "version": "08172021_EHL_MOSC",
  //     "assetType": "form",
  //     "title": "",
  //     "contents": [
  //       {
  //         "contentType": "text",
  //         "title": "",
  //         "data": "https://s3.amazonaws.com/prod.mosaic.disclosure-assets/EHL.png"
  //       }
  //     ]
  //   },
  //   {
  //     "assetCode": "ARB",
  //     "version": "11122021_ARB_MOSC",
  //     "assetType": "form",
  //     "title": "",
  //     "contents": [
  //       {
  //         "contentType": "text",
  //         "title": "",
  //         "data": "AGREEMENT TO ARBITRATE ANY DISPUTES WITH US\nThis arbitration provision does not apply if you are a member of the armed forces or a dependent of such member covered by the federal Military Lending Act. If you would like more information about whether you are covered by the Military Lending Act, you may contact us toll free at: (855) 345-4252.\nYou agree that unless you reject this arbitration provision as described below, you and Mosaic Platform Lenders, may elect to have any and all claims arising from or relating to these Important Terms and Conditions or any service provided to you by us or by the Installation Contractor submitted to binding arbitration under the Federal Arbitration Act (“FAA”). This includes claims based on contract, tort, equity, statute, or otherwise; however, claims regarding the scope and enforceability of this arbitration provision shall be determined by a court. It includes all claims by or against you, us, the Installation Contractor and others providing or receiving any product or service related to this Agreement or your credit application. Small claims court actions are not subject to this arbitration provision as long as they remain in that court.\nIf arbitration is elected, a single arbitrator shall decide all claims and shall render a final, written decision. The initiating party may choose the American Arbitration Association (“AAA”), Judicial Arbitration and Mediation Service (“JAMS”), or other similar arbitration service provider acceptable to us to administer the arbitration. If none of them can serve, a court with jurisdiction will select the arbitrator. Consistent with the FAA, the appropriate AAA rules, JAMS rules, or other service provider rules shall apply, as determined by the arbitrator. For AAA and JAMS, these rules are found at www.adr.org and www.jamsadr.com.\nEach party to the arbitration shall pay his, her, or its own costs of arbitration as specified by the relevant rules. If you cannot afford your arbitration costs, you may apply for a waiver under the relevant rules.\nIf a claim is arbitrated, the parties waive any right to a jury trial. They also waive any right to bring representative claims in court or in arbitration on behalf of a class of individuals, on behalf of the public, as a private attorney general, or otherwise, or to join or consolidate claims (the “class action waiver”).\nThis arbitration provision may be severed or modified if necessary to render it enforceable under the FAA, except that: (A) if the class action waiver is declared invalid in a proceeding between you and us, without in any way impairing the right to appeal such decision, this entire arbitration provision (other than this sentence) shall be null and void in such proceeding; and (B) if a claim is brought seeking public injunctive relief and a court determines that the restrictions in the class action waiver or elsewhere in this arbitration provision prohibiting the arbitrator from awarding relief on behalf of third parties are unenforceable with respect to such claim (and that determination becomes final after all appeals have been exhausted), the claim for public injunctive relief will be determined in court and any individual claims seeking monetary relief will be arbitrated. In such a case the parties will request that the court stay the claim for public injunctive relief until the arbitration award pertaining to individual relief has been entered in court.\nRIGHT TO REJECT ARBITRATION PROVISION: You may reject this arbitration provision by mailing a written arbitration rejection notice to 601 12th Street, Suite 325, Oakland, CA 94607 within thirty (30) calendar days after the date you agree to these Important Terms and Conditions. Any rejection notice must include your name, address, email address, and telephone number and a statement that you reject the arbitration provision in the Important Terms and Conditions. If you reject this arbitration provision, that will not affect any other part of these Important Terms and Conditions. Please note that if you enter into a credit agreement through the Mosaic Platform, the credit agreement will contain a separate arbitration provision with a right to reject arbitration. Rejecting this arbitration provision will not constitute a rejection of the arbitration provision in the credit agreement."
  //       }
  //     ]
  //   },
  //   {
  //     "assetCode": "ECOA",
  //     "version": "08172021_ECOA_MOSC",
  //     "assetType": "checkbox",
  //     "title": "",
  //     "contents": [
  //       {
  //         "contentType": "text",
  //         "title": "",
  //         "data": "Your annual pre-tax (gross) income. Alimony, child support, and separate maintenance income are optional."
  //       }
  //     ]
  //   },
  //   {
  //     "assetCode": "ESIGN_1",
  //     "version": "08172021_ESIGN_1_MOSC",
  //     "assetType": "form",
  //     "title": "",
  //     "contents": [
  //       {
  //         "contentType": "text",
  //         "title": "",
  //         "data": "DISCLOSURE AND CONSENT TO ELECTRONIC RECEIPT OF LOAN DISCLOSURES\nMosaic Platform Lenders, their assigns, successors, agents, representatives, vendors, servicers (collectively, “we” or “us”) may be required by law to give you certain information “in writing”, or electronically with your informed consent. You agree, in accordance with the terms set forth below, to the electronic receipt of information and disclosures and the use of electronic signatures, in connection with the Mosaic platform or any products or services offered through the Mosaic platform, including any credit application, any resulting loan agreement, any disclosures relating to your application and/or loan agreement, any payment plan, or any other agreement related to your application and/or loan agreement (collectively, “Loan Disclosures”).\nPlease read the information below carefully and thoroughly.\nYou acknowledge and agree that we may provide you with the Loan Disclosures in electronic format, and that we are not required to send a paper document to you, unless and until you withdraw your consent as described below. All Loan Disclosures that we provide to you in electronic format will be provided in one of the following formats: (i) on our online platform, including the DocuSign, Inc. (“DocuSign”) electronic signing system; (ii) via e-mail which may include attached Portable Document Format (PDF) documents; or (iii) via a text message to your mobile device through an HTML hyperlink that may link to our online platform or to PDF documents. Loan Documents on our online platform, including DocuSign, may be downloaded or printed as PDF documents.\n1. Getting paper copies. You may request from us a paper copy of any Loan Disclosure provided or made available to you electronically without charge, provided that such request is made within a reasonable time after the Loan Disclosure was first provided to you. To request paper copies, you must call (855) 746-7849 or send an e-mail to support@joinmosaic.com with the subject line “Past Paper Copy Request” and in the body of the e-mail you must state your e-mail address, full name, US Postal address, and telephone number.\n2. Withdrawing your consent. If your consent to receive electronic disclosures was provided via text message, replying to any text message that we send to you with only the word “STOP” will withdraw your consent for disclosure via SMS message. If your consent to receive Loan Disclosures was provided via text message and you also separately provided your consent to receive Loan Disclosures by email, replying to any text message that we send to you with only the word “STOP” will only withdraw your consent to receive Loan Disclosures via text message. We will continue to send you Loan Disclosures via e-mail. You may withdraw your consent to receive Loan Disclosures in all electronic forms by calling (855) 746-7849, or by sending an e-mail to support@joinmosaic.com with the subject line of “Future Paper Copy Request” and in the body of the e-mail request you must state your e-mail address, full name, US Postal Address, and telephone number. Your withdrawal of consent will be effective only after we have had a reasonable period of time to process your request. If you withdraw your consent to receive Loan Disclosures in electronic form, we will deliver your Loan Disclosures only in paper format. Please be aware that if you elect to receive Loan Disclosures only in paper format prior to the submission of an application, your application will not be processed. If you elect to receive Loan Disclosures only in paper format after your loan is approved, it may slow the speed at which services can be delivered to you.\n3. To advise of your new e-mail address or mobile phone number. If you enroll in electronic disclosures by e-mail, you are required to provide us with an accurate and complete e-mail address and promptly notify us if you change your e-mail address. To let us know of a change in your e-mail address, you must send an e-mail message to support@joinmosaic.com with the subject line “Email Address Change” and in the body of the e-mail you must state your previous e-mail address and your new e-mail address. If you enroll in electronic disclosures by text message, you are required to provide us with an active mobile phone number and promptly notify us if you change your mobile phone number. To let us know of a change in your mobile phone number, you must send an e-mail message to support@joinmosaic.com with the subject line “Mobile Number Change” and in the body of the e-mail you must state your previous mobile phone number and your new mobile phone number. Your failure to provide a valid e-mail address / mobile phone number or the malfunction of a previously valid e-mail address / mobile number may be treated as a withdrawal of your consent to receive electronic documents.\n4. Required hardware and software. In order to access, view, and retain the Loan Disclosures we make available to you in electronic form, you must provide at your own expense an Internet connected device. You must also have the following additional hardware and software requirements:\n\nDesktop Operating System: If you intend to access Loan Disclosures through a desktop computer, you will need a recent operating system that supports the Internet Browser, PDF Reader, E-Mail, and Storage Capacity requirements listed below, such as Microsoft Windows (Windows 2000 or higher) or Apple OS (OS X or higher).\nMobile Operating System: If you intend to access Loan Disclosures through a mobile device (such as a smart phone, tablet, or similar device), you will need a recent operating system that supports the Internet Browser, PDF Reader, E-Mail or SMS Access, and Storage Capacity requirements listed below, such as Android OS (Android 9 or higher) or Apple iOS (iOS 11 or higher).\nInternet Browsers: Final release versions of: Edge 42® or higher (Windows or Android), Google® Chrome™ 71 or higher (Windows, macOS, Android or iOS), Mozilla Firefox 47 or higher (Windows, Android or macOS), Firefox 18 or higher (iOS), Safari™ 11 or higher (macOS or iOS), Opera 57 or higher (Windows), Opera Touch 1.10 or higher (iOS or Android), Samsung internet browser (Android). Pre-release (e.g. beta) versions of browsers are not supported.\nInternet Browser Settings: Allow per session cookies; must be JavaScript-enabled. PDF Reader: Software that enables you to view and print Portable Document Files (PDF), such as Adobe® Acrobat Reader or similar. To the extent your desktop computer or Android mobile device does not already have such software installed, you can install Adobe Reader here . To the extent your Apple mobile device does not already have such software installed, you can install Adobe Reader through the App Store. Other options may also be available.\nE-Mail: An active e-mail account and e-mail software that can display e-mails.\nText Message (SMS) Access: If you wish to access Loan Disclosures through text messages that include HTML links, you will need a cellular plan that includes the capability to receive text messages. Your cellular plan will also need to include capability allowing you to access the internet through the service (i.e., a data plan). Alternatively, you will need the capability to receive text messages and access the Loan Disclosures when connected to a wireless network.\nStorage Capacity: Sufficient electronic storage capacity on your computer’s hard drive, mobile device, or other data storage media or service to retain the Loan Disclosures and/or a printer to print them.\n\nWe reserve the right to discontinue support of a version of hardware or software mentioned above if, in our sole opinion, it suffers from a security flaw or other flaw that makes it unsuitable for use with Loan Disclosures. If our hardware or software requirements change, and that change would create a material risk that you would not be able to access or retain your Electronic Disclosures, we will give you notice of the revised hardware or software requirements. Continuing to use electronic services after receiving notice of the change is reaffirmation of your consent.\n5. Federal Law. All Loan Disclosures we provide to you in either electronic or paper format will be considered “in writing.” You should print or download for your records a copy of this Disclosure and Consent to Electronic Receipt of Loan Disclosures (“E-Sign Consent”) and any other Loan Disclosures. You agree and we both intend the federal Electronic Signatures in Global and National Commerce Act to apply to (i) this E-Sign Consent and (ii) our ability to conduct business with you by electronic means.\n6. Termination/Changes. We reserve the right, in our sole discretion, to provide you with any Loan Disclosures in paper format and to discontinue electronic provision of Loan Disclosures at any time. We will provide you with notice of any such termination or change as required by law.\n7. Acknowledging your access and consent to receive materials electronically.\nBy signing below, you: (i) confirm your consent to receive Loan Disclosures in electronic format; (ii) affirmatively demonstrate your ability to access and read, and also print or save, this E-Sign Consent and the Loan Disclosures; (iii) confirm that you have provided a valid e-mail address at which we can send electronic Loan Disclosures to you; (iv) have access to software and hardware that satisfies the above requirements; (v) agree to the terms and conditions of this E-Sign Consent; and (vi) affix your electronic signature to this E-Sign Consent."
  //       }
  //     ]
  //   },
  //   {
  //     "assetCode": "INCOME",
  //     "version": "08172021_INCOME_MOSC",
  //     "assetType": "checkbox",
  //     "title": "",
  //     "contents": [
  //       {
  //         "contentType": "text",
  //         "title": "",
  //         "data": "Personal Income (annual)\nYour annual pre-tax (gross) income. Alimony, child support, and separate maintenance income are optional. You may include any source of income you wish to have considered as a basis for repaying this obligation, for example - salary, wages, interest, dividends, rental income, retirement benefits. Alimony, child support, or separate maintenance income need not be revealed if you do not wish to have it considered as a basis for repaying this obligation."
  //       }
  //     ]
  //   },
  //   {
  //     "assetCode": "OTHERINC",
  //     "version": "08172021_OTHERINC_MOSC",
  //     "assetType": "checkbox",
  //     "title": "",
  //     "contents": [
  //       {
  //         "contentType": "text",
  //         "title": "",
  //         "data": "Other gross income for household members at the same address."
  //       }
  //     ]
  //   },
  //   {
  //     "assetCode": "OWN",
  //     "version": "08172021_OWN_MOSC",
  //     "assetType": "checkbox",
  //     "title": "",
  //     "contents": [
  //       {
  //         "contentType": "text",
  //         "title": "",
  //         "data": "I declare that I own the project address in my name or directly through a trust where I am the trustee."
  //       }
  //     ]
  //   },
  //   {
  //     "assetCode": "PAD",
  //     "version": "08172021_PAD_MOSC",
  //     "assetType": "form",
  //     "title": "",
  //     "contents": [
  //       {
  //         "contentType": "text",
  //         "title": "",
  //         "data": "PATRIOT ACT DISCLOSURE\nTo help the government fight the funding of terrorism and money laundering activities, federal law requires all financial institutions to obtain, verify, and record information that identifies each person who opens an account. What this means for you: When you open an account we will ask for your name, address, date of birth, and other information that will allow us to identify you. We may also ask to see your driver's license or other identifying documents."
  //       }
  //     ]
  //   },
  //   {
  //     "assetCode": "STATE",
  //     "version": "08172021_STATE_MOSC",
  //     "assetType": "form",
  //     "title": "",
  //     "contents": [
  //       {
  //         "contentType": "text",
  //         "title": "",
  //         "data": "STATE DISCLOSURE NOTICES\nCalifornia. A married applicant may apply for a separate account. Civ. Code § 1812.30(j).\nMichigan. Notice to inquirers and loan applicants: You have a right to submit a written application for a home improvement loan or to request written information concerning typical loan terms that we are currently offering on home improvement loans. It is illegal to establish a minimum home improvement loan of more than $1,000.00. It is illegal to deny a loan or vary the terms and conditions of a loan because of the racial or ethnic trends or characteristics of the neighborhood or the age of the structure, but not because of its physical condition. If your application for a loan is rejected, you have a right to a written statement of the reason for the rejection. If you are granted a loan but the amount required for down payment, the interest rate, term to maturity, application procedure, or other terms or conditions of the loan vary from terms or conditions offered in other neighborhoods, you have a right to a written statement of the reasons for the variation. The rights described in this notice are set forth in and limited by M.C.L.A. 445.1601 through 445.1614. If you believe that your rights under this act have been violated, you should contact the financial institutions bureau of the Michigan Department of Commerce, 877-999-6442.\nNew York. I understand and agree that you may obtain a consumer credit report in connection with this application and in connection with any updates, renewals or extensions of any credit as a result of this application. If I ask, I will be informed whether or not such a report was obtained and, if so, the name and address of the agency that furnished the report. I also understand and agree that you may obtain a consumer credit report in connection with the review or collection of any loan made to me as a result of this application or for other legitimate purposes related to such loans.\nOhio. The Ohio laws against discrimination require that all creditors make credit equally available to all credit worthy customers, and that credit reporting agencies maintain separate credit histories on each individual upon request. The Ohio civil rights commission administers compliance with this law.\nRhode Island. I understand and agree that you may obtain a consumer credit report in connection with this application and in connection with any updates, renewals or extensions of any credit as a result of this application. If I ask, I will be informed whether or not such a report was obtained and, if so, the name and address of the agency that furnished the report. I also understand and agree that you may obtain a consumer credit report in connection with the review or collection of any loan made to me as a result of this application or for other legitimate purposes related to such loans.\nVermont. I understand and agree that you may obtain a consumer credit report in connection with this application and in connection with any updates, renewals or extensions of any credit as a result of this application. If I ask, I will be informed whether or not such a report was obtained and, if so, the name and address of the agency that furnished the report. I also understand and agree that you may obtain a consumer credit report in connection with the review or collection of any loan made to me as a result of this application or for other legitimate purposes related to such loans.\nWisconsin. If I am a married Wisconsin resident, I understand that no provision of any marital property agreement, unilateral statement under § 766.59 of the Wisconsin Statutes, or court decree under § 766.70 adversely affects your interest unless prior to the time that the loan is approved, you are furnished with a copy of the marital property agreement, statement, or decree or have actual knowledge of the adverse provision."
  //       }
  //     ]
  //   },
  //   {
  //     "assetCode": "GD",
  //     "version": "11122021_GD_MOSC",
  //     "assetType": "form",
  //     "title": "",
  //     "contents": [
  //       {
  //         "contentType": "text",
  //         "title": "",
  //         "data": "PLEASE CAREFULLY READ THESE IMPORTANT TERMS AND CONDITIONS WHICH CONTAIN THE FOLLOWING IMPORTANT TERMS:\n\nAuthorization to Obtain Your Consumer Reports and Share Information\nDisclosure and Consent to Electronic Receipt of Loan Disclosures (“E-Sign Consent”)\nAutomated Calling/Text Messaging and Call Recording Consent\nAgreement to Arbitrate Disputes\nState Disclosure Notices, and\nPATRIOT Act Disclosure (collectively, “Important Terms and Conditions”).\n\nThese Important Terms and Conditions form a legally binding agreement between you and Solar Mosaic LLC (“Mosaic”), its successors, agents, assigns, affiliates, affiliate companies, vendors, representatives, third party lending and financial partners, banks that originate loans on the Solar Mosaic LLC lending platform (including but not limited to credit unions and other financial institutions) (“Mosaic Platform Lender(s)”), loan servicers and each of the foregoing’s respective service providers (collectively, “we”, “us”, or “our”).\nBy checking the box and clicking the button appearing below these Important Terms and Conditions, you are indicating that you agree to be bound by these Important Terms and Conditions. If you do not agree to be bound by these Important Terms and Conditions, then do not check the box and do not click the button appearing below these Important Terms and Conditions.\nTHESE IMPORTANT TERMS AND CONDITIONS INCLUDE A MANDATORY ARBITRATION AGREEMENT, WHICH MEANS THAT YOU AGREE THAT EITHER YOU OR WE MAY ELECT TO HAVE ANY CLAIM (AS DESCRIBED) SUBMITTED TO BINDING INDIVIDUAL ARBITRATION RATHER THAN PROCEEDING IN COURT OR BEFORE A JURY. THE ARBITRATION AGREEMENT ALSO INCLUDES A CLASS ACTION WAIVER, WHICH MEANS THAT YOU AGREE TO PROCEED WITH ANY CLAIM INDIVIDUALLY AND NOT AS A MEMBER OF A CLASS ACTION. YOU HAVE A RIGHT TO REJECT THE ARBITRATION AGREEMENT AS DESCRIBED."
  //       }
  //     ]
  //   },
  //   {
  //     "assetCode": "TCPA_1",
  //     "version": "08172021_TCPA_1_MOSC",
  //     "assetType": "sms",
  //     "title": "",
  //     "contents": [
  //       {
  //         "contentType": "text",
  //         "title": "",
  //         "data": "CALLING/TEXT MESSAGING & CALL RECORDING CONSENT\nYou agree to the terms of this Calling/Text Messaging and Call Recording Consent. You agree that Mosaic Financing Partners, their assigns, successors, agents, representatives, vendors, servicers (collectively, “we,” or “us”) may contact you at the number(s) you have provided on or with your application for credit or any other number you provide to us, including through automated telephone dialing and text messaging systems to deliver messages or with the use of prerecorded and/or artificial voice. Among other reasons, we may contact you to market products or services to you, with information or questions about your account relationship, regarding your application(s) current, future or past account(s), payments and other important communications relating to your account(s). Telephone messages may be played by a machine automatically when the telephone is answered, whether answered by you or someone else. These messages may also be recorded by your answering machine.\nYou also understand and agree that, subject to applicable law, we may monitor and/or record any of your phone conversations with any of our representatives for training, quality control, evidentiary, and any other purposes. However, we are not under any obligation to monitor, record, retain, or reproduce such recordings, unless required by applicable law.\nYou understand that, when you receive such calls or text messages, you may incur a charge from the company that provides you with telecommunications services. You agree that we will not be liable to you for any fees, inconvenience, annoyance or loss of privacy in connection with such calls or text messages. You understand that anyone with access to your telephone or email account may listen to or read the messages, notwithstanding our efforts to communicate only with you. If a telephone number(s) you have provided to us changes, or if you cease to be the owner, subscriber, or primary user of such telephone number(s), you agree to immediately give us notice of such facts so that we may update our records. To request additional information, text “HELP” to any text message you receive or contact us by telephone at (855) 746-7849. To stop receiving text messages from us, you may reply to any text message that we send to you or initiate a text message to us at 66742 with only the word “STOP.” We will process your request to stop receiving text messages within a reasonable time. To stop receiving autodialed and/or prerecorded/artificial voice calls from us, please contact us at (855) 746-7849 or support@joinmosaic.com."
  //       }
  //     ]
  //   },
  //   {
  //     "assetCode": "MPP",
  //     "version": "08172021_MPP_MOSC",
  //     "assetType": "form",
  //     "title": "",
  //     "contents": [
  //       {
  //         "contentType": "text",
  //         "title": "",
  //         "data": "For information about our collection, sharing, and use of your personal information, please see our privacy policy (https://www.joinmosaic.com/privacypolicy/)."
  //       }
  //     ]
  //   },
  //   {
  //     "assetCode": "TRUELENDER",
  //     "version": "11122021_TRUELENDER_MOSC",
  //     "assetType": "form",
  //     "title": "",
  //     "contents": [
  //       {
  //         "contentType": "text",
  //         "title": "",
  //         "data": "Financing applied for and processed through the Mosaic platform is originated by Solar Mosaic LLC or one of its lending/financing partners. Refer to transaction specific disclosures and loan documents for details and additional information."
  //       }
  //     ]
  //   }
  // ]

  let fullBirthDate = moment(`${birthYear}-${birthMonth}-${birthDay}`).format('YYYY-MM-DD');

  let applicant = ''

  if (+view === 1) {
    applicant = {
      "applicants": [
        {
          "language": "en",
          "firstName": firstName,
          "middleName": middleName,
          "lastName": lastName,
          "emailAddress": emailA,
          "addresses": [
            {
              "street": streetA,
              "city": cityA,
              "stateAbbreviation": abbrState,
              "zipCode": zipA,
              "residenceType": "Primary",
              "addressTags": [
                "Billing"
              ]
            }
          ],
          "phoneNumber": `+1${phoneNumber.replace(/\D/g, "")}`,
          "dateOfBirth": fullBirthDate,
          "socialSecurityNumber": social.replace(/\D/g, ""),
          "annualIncome": annualIncome,
          "otherHouseholdIncome": secondaryIncome,
          "applicantType": "Primary"
        }
      ],
      "disclosuresBundleId": bunId,
      // "salesRepIdentifier": 'qa+unassigned+ionsolar@joinmosaic.com',
      "salesRepIdentifier": activeUser.username,
      "externalId": "string"
    }
  }

// console.log(applicant)
  useEffect(() => {

    if (disclosures.length > 0) {
      disclosures.forEach((obj, i) => {
        if (obj.assetCode === 'ECOA') {
          setEcoa(obj.contents[0].data)
        } if (obj.assetCode === 'CPA_2') {
          setCpa2(obj.contents[0].data)
        } if (obj.assetCode === 'EHL') {
          setEhl(obj.contents[0].data)
        } if (obj.assetCode === 'ARB') {
          setArb(obj.contents[0].data)
        } if (obj.assetCode === 'ESIGN_1') {
          setEsign(obj.contents[0].data)
        } if (obj.assetCode === 'INCOME') {
          setIncome(obj.contents[0].data)
        } if (obj.assetCode === 'OTHERINC') {
          setOtherInc(obj.contents[0].data)
        } if (obj.assetCode === 'OWN') {
          setOwn(obj.contents[0].data)
        } if (obj.assetCode === 'PAD') {
          setPad(obj.contents[0].data)
        } if (obj.assetCode === 'STATE') {
          setStateDisc(obj.contents[0].data)
        } if (obj.assetCode === 'GD') {
          setGd(obj.contents[0].data)
        } if (obj.assetCode === 'TCPA_1') {
          setTcpa(obj.contents[0].data)
        } if (obj.assetCode === 'MPP') {
          setMpp(obj.contents[0].data)
        } if (obj.assetCode === 'TRUELENDER') {
          setTrueLender(obj.contents[0].data)
        }
      })
    }
  }, [disclosures])

  let states = [
    { state: "California" },
    { state: "Colorado" },
    { state: "Florida" },
    { state: "Idaho" },
    { state: "Nevada" },
    { state: "New Jersey" },
    { state: "New Mexico" },
    { state: "North Carolina" },
    { state: "Oregon" },
    { state: "South Carolina" },
    { state: "Texas" },
    { state: "Utah" },
    { state: "Virginia" },
    { state: "Wyoming" }
  ]



  const addMosaicApp = (appId) => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'add_mosaic_app', project_id: projectID, application_id: appId })
      .then((res, err) => {
        if (err) {
          console.log(err)
        }
        // console.log(res)
      })
  }

  const getMosaicApp = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'get_mosaic_app', project_id: projectID })
      .then((res, err) => {
        if (err) {
          console.log(err)
        }
        // console.log(res.data)
        if (res.data.data.appId) {
          setApplicationId(res.data.data.appId)
          mosaicApiGetApp('getApp', res.data.data.appId)
          setConfirmedApp(true)
        }
      })
  }


  const mosaicApiGetApp = (method, appId) => {
    axios.post(`https://staging.proposalist.iondeveloper.com/mosaicProposal.php`,
      {
        method: method,
        appId: appId,
      }).then((res, err) => {
        if (err) {
          console.log(err)
        }
        // console.log(res.data)
        if (res.data.decision.result) {
          setCreditMessage(res.data.decision)
          setCreditResult(res.data.decision.result)
        }

      })
  }

  const mosaicApi = (method, applicant) => {
    axios.post(`https://staging.proposalist.iondeveloper.com/mosaicProposal.php`,
      {
        method: method,
        applicant: JSON.stringify(applicant)
      }).then((res, err) => {
        if (err) {
          console.log(err)
        }
        // console.log(res.data.errors)
        if (res.data.errors) {
          return Alert.error(`${res.data.errors[0].message}`, {
            position: 'top-right',
            effect: 'flip',
            beep: false,
            timeout: 5000,
            offset: 100,
            color: 'rgba(255, 255, 255, 0.927)'
          })
        }
        if (res.data.application.id) {
          addMosaicApp(res.data.application.id)
          setApplicationId(res.data.application.id)
          setConfirmedApp(true)
          creditLoad()
        }

      })
  }

  useEffect(() => {
    setSocial(social.replace(/\D/g, ""))
  }, [social])



  useEffect(() => {
    getMosaicApp()
  }, [])

  const createApplication = () => {
    if (social.length !== 9) {
      return Alert.error(`Please add customer's full social`, {
        position: 'top-right',
        effect: 'flip',
        beep: false,
        timeout: 5000,
        offset: 100,
        color: 'rgba(255, 255, 255, 0.927)'
      })
    }
    if (annualIncome === '') {
      return Alert.error(`Please add customer's annual income`, {
        position: 'top-right',
        effect: 'flip',
        beep: false,
        timeout: 5000,
        offset: 100,
        color: 'rgba(255, 255, 255, 0.927)'
      })
    }
    if (birthDay === '' || birthMonth === '' || birthYear === '') {
      return Alert.error(`Please add customer's date of birth info`, {
        position: 'top-right',
        effect: 'flip',
        beep: false,
        timeout: 5000,
        offset: 100,
        color: 'rgba(255, 255, 255, 0.927)'
      })
    }
    return mosaicApi('creditApp', applicant)
  }

  // <CircularProgress size={40} color="inherit" /> 

  return (
    <>
      {confirmedApp ? (
        <>
          <div>
            <span>{firstName} {lastName}</span>
          </div>
          <div>
            <span>Phone - {phoneNumber}</span>
          </div>
          <div>
            <span>Email - {emailA}</span>
          </div>
          <div>
            <span>Address - {streetA}, {cityA}, {stateA} {zipA}</span>
          </div>
          <div>
            {annualIncome ? <span>Annual Income - ${annualIncome}</span> : ''}
          </div>
          <div>
            {birthMonth ? <span>Date of Birth - {birthMonth}/{birthDay}/{birthYear}</span> : ''}
          </div>
          <div>
            <div>
              <span>Credit Decision - {creditResult}</span>
            </div>
            <div>
              {creditResult === 'Approved' || creditMessage.status === 'ApprovedWithStipulations' ? (
                <>
                  <div>
                    <span>LOAN AMOUNT - {creditMessage.applicantMessages.actualLoanAmount}</span>
                  </div>
                  <div>
                    <span>BORROWING AMOUNT - {creditMessage.applicantMessages.borrowingLimit}</span>
                  </div>
                  <div>
                    <span>APPLICATION EXPIRATION - {creditMessage.applicantMessages.expiration}</span>
                  </div>
                </>
              ) : creditResult === 'Declined' ? (
                <>
                  <span>CREDIT INFO - {creditMessage.applicantMessages.notApproved}</span>
                </>

              ) : (
                <>
                </>
              )}
            </div>
          </div>
          <div>
            {creditResult === 'Pending' ? <Button disabled={loading} variant='outlined' onClick={() => mosaicApiGetApp('getApp', applicationId)}>{loading ? <CircularProgress size={40} color="inherit" /> : 'Get Credit Result'}</Button> : ''}
          </div>
          <div>
            <Button variant='outlined' onClick={() => { setOwnHome(false); setAgree(false); setConfirmedApp(false); setCreditMessage({}); setCreditResult('Pending') }}>New Application</Button>
          </div>
        </>
      ) : (
        <>
          <div style={{ overflow: 'scroll' }}>
            <h2>Mosaic Pre-Qualification</h2>
            <form noValidate>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} >
                <div>
                  <TextField style={{ width: 240 }} label={names[0]} size="small" margin="dense" onChange={e => setFirstName(e.target.value)}></TextField>
                </div>
                <div>
                  <TextField style={{ width: 240 }} label={middleName !== 'string' ? middleName : 'Middle Name'} size="small" margin="dense" onChange={e => setMiddleName(e.target.value)}></TextField>
                </div>
                <div>
                  <TextField style={{ width: 240 }} label={names[1]} size="small" margin="dense" onChange={e => setLastName(e.target.value)}></TextField>
                </div>
                <div>
                  <span style={{ fontWeight: 'bold' }} >CONTACT</span>
                </div>
                <div>
                  <TextField style={{ width: 240 }} label={phoneNumber ? `+1 ${phoneNumber}` : `+1 ${phone}`} size="small" margin="dense" type='tel' InputProps={{ inputProps: { min: 0, max: 10 } }} onChange={e => setPhoneNumber(e.target.value)}></TextField>
                </div>
                <div>
                  <TextField style={{ width: 240 }} label={email ? email : 'email'} size="small" margin="dense" onChange={e => setEmailA(e.target.value)}></TextField>
                </div>
                <div>
                  <TextField style={{ width: 240 }} label={'annual income'} type='number' size="small" margin="dense" onChange={e => setAnnualIncome(e.target.value)}></TextField>
                  <div>
                    {viewIncome ? <span>{income}</span> : <span>{ecoa} <button onClick={() => setViewIncome(!viewIncome)}>read more</button></span>}
                  </div>
                </div>
                <div>
                  <TextField style={{ width: 240 }} label={'other household income'} size="small" margin="dense" type='number' onChange={e => setSecondaryIncome(e.target.value)}></TextField>
                  <div>
                    <span>{otherInc}</span>
                  </div>
                </div>
                <div>
                  <span style={{ fontWeight: 'bold' }} >ADDRESS</span>
                </div>
                <div>
                  <TextField style={{ width: 240 }} label={street} size="small" margin="dense" onChange={e => setStreetA(e.target.value)}></TextField>
                </div>
                <div>
                  <TextField style={{ width: 240 }} label={city} size="small" margin="dense" onChange={e => setCityA(e.target.value)}></TextField>
                </div>
                <div>
                  <Autocomplete disableClearable id="tags-outlined-states" options={states} getOptionSelected={(option, value) => option.value === value.value} getOptionLabel={(option) => `${option.state}`} value={states.state} onChange={(event, value) => setStateA(value.state)} style={{ width: 240 }}
                    renderInput={(params) => (
                      <TextField   {...params} size="small" label={state} margin="dense"
                      />
                    )}
                  />
                </div>
                <div>
                  <TextField style={{ width: 240 }} label={zip} size="small" type='number' margin="dense" onChange={e => setZipA(e.target.value)}></TextField>
                </div>
                <div>
                  <span style={{ fontWeight: 'bold' }} >PERSONAL INFO</span>
                </div>
                <div>
                  <TextField style={{ width: 240 }} label={'full social'} size="small" margin="dense" onChange={e => setSocial(e.target.value)}></TextField>
                </div>
                <div>
                  <TextField style={{ width: 240 }} label={'month - 00'} size="small" type='number' margin="dense" onChange={e => setBirthMonth(e.target.value)}></TextField>
                  <TextField style={{ width: 240 }} label={'day - 00'} size="small" type='number' margin="dense" onChange={e => setBirthDay(e.target.value)}></TextField>
                  <TextField style={{ width: 240 }} label={'year - 0000'} size="small" type='number' margin="dense" onChange={e => setBirthYear(e.target.value)}></TextField>
                </div>
              </div>

              <div style={{ textAlign: 'left' }}>
                <div>
                  <span>For information about our collection, sharing, and use of your personal information, please see our <a href='https://joinmosaic.com/privacy/' target='blank'> privacy policy.</a></span>
                </div>
                <div>
                  <span>{trueLender}</span>
                </div>
                <div>
                  <img src={ehl}></img>
                </div>
                <div>
                  <span>{pad}</span>
                </div>
                <div>
                  {viewGd ? (
                    <>
                      <div>
                        <span>General Disclosures</span>
                      </div>
                      <div>
                        <span>{gd}</span>
                      </div>
                      <div>
                        <Button onClick={() => setViewGd(!viewGd)}>Close</Button>
                      </div>
                    </>
                  ) : (
                    <div>
                      <Button variant='outlined' onClick={() => setViewGd(!viewGd)}>General Disclosures</Button>
                    </div>
                  )}
                  {viewCpa2 ? (
                    <>
                      <div>
                        <span>{cpa2}</span>
                      </div>
                      <div>
                        <Button onClick={() => setViewCpa2(!viewCpa2)}>Close</Button>
                      </div>
                    </>
                  ) : (
                    <div>
                      <Button variant='outlined' onClick={() => setViewCpa2(!viewCpa2)}>Authorization to Obtain Your Consumer Reports and Share Information</Button>
                    </div>
                  )}
                  {viewEsign ? (
                    <>
                      <div>
                        <span>{esign}</span>
                      </div>
                      <div>
                        <Button onClick={() => setViewEsign(!viewEsign)}>Close</Button>
                      </div>
                    </>
                  ) : (
                    <div>
                      <Button variant='outlined' onClick={() => setViewEsign(!viewEsign)}>Electronic Communications Consent</Button>
                    </div>
                  )}
                  {viewTcpa ? (
                    <>
                      <div>
                        <span>{tcpa}</span>
                      </div>
                      <div>
                        <Button onClick={() => setViewTcpa(!viewTcpa)}>Close</Button>
                      </div>
                    </>
                  ) : (
                    <div>
                      <Button variant='outlined' onClick={() => setViewTcpa(!viewTcpa)}>Automated Calling/Text Messaging and Call Recording Consent</Button>
                    </div>
                  )}
                  {viewArb ? (
                    <>
                      <div>
                        <span>{arb}</span>
                      </div>
                      <div>
                        <Button onClick={() => setViewArb(!viewArb)}>Close</Button>
                      </div>
                    </>
                  ) : (
                    <div>
                      <Button variant='outlined' onClick={() => setViewArb(!viewArb)}>an Arbitration Provision</Button>
                    </div>
                  )}
                  {viewStateDisc ? (
                    <>
                      <div>
                        <span>{stateDisc}</span>
                      </div>
                      <div>
                        <Button onClick={() => setViewStateDisc(!viewStateDisc)}>Close</Button>
                      </div>
                    </>
                  ) : (
                    <div>
                      <Button variant='outlined' onClick={() => setViewStateDisc(!viewStateDisc)}>State Disclosure Notices</Button>
                    </div>
                  )}
                </div>
                <div>
                  <Button style={{ display: 'flex', width: '100%', height: '70px' }} onClick={e => { setAgree(!agree) }}>{agree ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />}I Agree to the Terms and Conditions above.</Button>
                </div>
                <div>
                  <Button style={{ display: 'flex', width: '100%', height: '70px' }} onClick={e => { setOwnHome(!ownHome) }}>{ownHome ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />}{own}</Button>
                </div>
              </div>
              <div>
                <Button variant='outlined' disabled={ownHome === true && agree === true ? false : true} onClick={() => { createApplication(); setLoading(true) }}>Submit Pre-Qualification</Button>
                <div>
                  <span>this won't affect your credit score!</span>
                </div>
              </div>
            </form>
          </div>
        </>
      )}

    </>
  )
}



export default MosaicCredit

